<template>
  <div>
    <div class="indexHeader" :class="{ active: activeClass }">
      <div class="container">
        <h1>
          <a href="index.html" class="toIndex"
            ><img src="./images/logo.png" alt="logo" class="activeLogo" /><img
              src="./images/newlogo.png"
              alt="logo"
              class="logo"
          /></a>
        </h1>
        <ul class="otherColor">
          <li class=""><a href="index.html">首 页</a></li>
          <li class=""><a href="supply.html" class="">产 品</a></li>
          <li class=""><a href="safe.html" class="">安 全</a></li>
          <li class=""><a href="news.html" class="">动 态</a></li>
          <li class=""><a href="services.html" class="">会 员</a></li>
          <li class=""><a href="case.html" class="">案 例</a></li>
          <li class=""><a href="products.html" class="">帮 助</a></li>
        </ul>
        <p><a href="signup.html">注 册</a><a href="userlogin.do">登 录</a></p>
      </div>
    </div>
    <div class="main">
      <div class="about-us">
        <h3 class="title">苏州罗想软件股份有限公司</h3>
        <div class="content">
          <p>江苏苏州市工业园区东长路88号G1栋16F</p>
          <p>江苏常熟市东南经济开发区金都路8号大学科技园6号楼3F</p>
          <p>
            Tel:0512 86868936
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fax:0512
            86868893(苏州）
          </p>
          <p>
            Tel:0512 81581008
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fax:0512
            81581012(常熟）
          </p>
          <p>Email: marketing@roadshare.com</p>
        </div>
      </div>
    </div>
    <rs-footer></rs-footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer'
export default {
  components: {
    'rs-footer': Footer
  },
  data () {
    return {
      activeClass: false
    }
  },
  mounted () {
    document.title = '联系我们 - TickLink即链'
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    this.activeClass = scrollTop > 0
    window.addEventListener('scroll', () => {
      this.activeClass = (document.documentElement.scrollTop || document.body.scrollTop) > 0
    }, false)
  }
}
</script>
<style>
@import "./styles/about.min.css";
.indexHeader {
  background-color: #6ea5f7;
}
.indexHeader ul > li a:after {
  background: #fff !important;
}
.indexHeader ul > li > a {
  color: #fff !important;
}
.indexHeader.active ul > li > a {
  color: #999 !important;
}
.indexHeader.active ul > li > a:after {
  background: #999 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/contact/app.vue